import React, { useState,useEffect } from 'react';

import axios from 'axios';
import { useParams,useHistory } from "react-router-dom";

import {Configs} from '../api';

const EditTodo =()=> {
    let history= useHistory();
    const id =useParams({})
  const [name, setname] = useState('')
  
const [catLoc, setcatLoc] = useState('')

const [barlocation, setlocation] = useState([])

  const adddata = async(e) =>{
    console.log(name,catLoc)
    try {
    console.log(name,catLoc)
    const result = await axios.post(Configs.categories+'/'+id.id,
    {
      name : name,
      locationId :catLoc
    })
    // console.log(result)
    history.push('/dashboard/categories')
    
  }
    catch (error) {
      console.log(error.message);
  }
  }


  useEffect(() => {
    const dataID = async() =>{

      try {
      const result = await axios.get(Configs.categories+'/'+id.id)
      setname(result.data.category.name)
     
    }
      catch (error) {
        console.log(error.message);
    }
    }
    const loadLocations= async()=>{
      // console.log(catLoc)
      try {
        const result = await axios.get(Configs.locations)
        // console.log(result.data.location)
        setlocation(result.data.location)
      }
        catch (error) {
          console.log(error.message);
      }
      }
    
    

    dataID();
    loadLocations();
  },[id.id]);
  
  return ( 

<div className="container-fluid box-styl" >
<h1 className="text-center mt-5">Edit Categories</h1>
<form className="d-flex mt-5 mb-5 algnItm"  onSubmit={e=>{adddata(e)}}>
<input type='text' 
          className="form-control input-styl1"
          value={name}
          onChange={e=> setname(e.target.value)}
            required
        >
           </input>
       
        <select id="dropdown" 
        value={barlocation._id} 
        className="form-control input-styl"
        onChange={(e)=>setcatLoc(e.target.value)} 
        required
        >
        
        <option value='' >select location</option>
        {barlocation.map((loc)=>(
          
       
          <option key={loc._id} value={loc._id}>{loc.name}</option>
        )
        )
        }
          
        </select>
       
          <button className="btn btn-success">Edit</button>

</form>
</div>
);
}

    
     
    export default EditTodo;